import { Theme } from '@mui/material/styles';
import { Colors } from 'src/theme/palette';

// ----------------------------------------------------------------------

export function card(theme: Theme) {
  return {
    MuiCard: {
      styleOverrides: {
        root: {
          position: 'relative',
          // boxShadow: theme.customShadows.card,
          border: `1px solid ${Colors.tableBorderColor}`,
          borderRadius: theme.shape.borderRadius,
          zIndex: 0, // Fix Safari overflow: hidden with border radius
          '@media print': {
            boxShadow: "none !important",
            borderRadius: "0px !important"
          }
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2, 2, 0),
        },
      },
    },
    MuiCardContent: {
      styleOverrides: {
        root: {
          padding: theme.spacing(2),
        },
      },
    },
  };
}
